import { BaseResource } from "utils/ApiUtils";

class Accident extends BaseResource {
  constructor(args) {
    super(args, Accident.attributes);
  }

  static columns = [
    {
      title: "Project Id",
      field: "ProjectId_WorkItem",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Accident Id",
      field: "accidentId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Ihwi Id",
      field: "ihwiId",
      type: "guid",
      hidden: true,
      hiddenByColumnsButton: true,
    },
    {
      title: "Occurrence Date",
      field: "occurrenceDate",
      type: "date",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    { type: "string", title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Description",
      field: "description",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Accident Report Yn",
      field: "accidentReportYn",
      type: "boolean",
      hidden: false,
      hiddenByColumnsButton: true,
    },
    {
      title: "Report Number",
      field: "reportNumber",
      type: "string",
      hidden: false,
      hiddenByColumnsButton: true,
    },
  ];

  static attributes = Accident.columns.map((r) => r.field);

  static expand = [
    {
      "Ihwi": {
        expand: [
          {
            "WorkItem": {
              select: ["ProjectId"]
            }   
          },
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }];
}

export default Accident;
